import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import EncryptStorage from 'encrypt-storage';
import { AuthService } from 'src/app/auth/auth.service';
import { DateRange, MomentHelper } from 'src/app/models/date';
import { ProductSearch } from 'src/app/models/product';
import { AvailableOptions, emptyFields, UsersType } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { Messages } from 'src/app/utilities/message';
import { NzDrawerService, NzModalRef, NzModalService, NzNotificationService } from 'src/app/utilities/ng-zorro-antd.module';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
 import { ProductOffersComponent } from '../product-offers/product-offers.component';
import { ProductService } from '../product.service';
import { AddLocationProductComponentComponent } from './add-location-product-component/add-location-product-component.component';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-location-product-component',
  templateUrl: './location-product-component.component.html',
 })
export class LocationProductComponentComponent implements OnInit {

  private tableData: NzTableData<ProductSearch, any> = new NzTableData<ProductSearch, any>(new ProductSearch(), 'name');
  loading = false;
  merchantId: any;
  locationId: any;
  currencySymbol='';
  selectedProduct: any;
  notifyLogout: any;
  selectedMerchantProduct: any;
  emptyField = emptyFields;
  availableOptions=AvailableOptions;
  commentForm: UntypedFormGroup;
  userType = UsersType;
  locationsList = [];
  productModal: NzModalRef;
  loginUserType = '';
  showDownload:string ;
  selectedRateDateRange: Date[] = null;
  constructor(
    private fb: UntypedFormBuilder,
    private productService: ProductService,
    private drawerService: NzDrawerService,
    private commonService: CommonService,
    private modal: NzModalService,
    private notification: NzNotificationService,
    private authService: AuthService) {
    this.commentForm = this.fb.group({
      comments: [''],
      isAvailable: [],
    });
  }
  ngOnInit() {
    this.locationId = this.authService.getLocationId();
    this.loginUserType = this.authService.getRole();
    this.tableData.search.isAvailable=true;
    this.merchantId = + encryptStorage.getItem('merchantId');
    this.currencySymbol = encryptStorage.getItem('currencySymbol');

    this.getLocations();
    this.refresh();
  }
  // For List
  refresh(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.search.merchantId = this.merchantId;
    if (this.loginUserType !== this.userType.merchantUser) {
      this.tableData.search.locationId = this.authService.getLocationId();
    }
    this.productService.getMerchantLocationProductlist(this.tableData).subscribe((response: any) => {
        this.loading = false;
      this.tableData.total = response.data.total;
      this.tableData.data = response.data.merchantLocationProducts;
    }, () => {
      this.loading = false;
    });
  }
  // For Date range change
  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) { return; }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.refresh();
  }
  // To Clear date range
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
    }
  }
  // For Available Tag color
  getAvailableColor(value) {
    return this.commonService.getAvailableColor(value);
  }
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
    this.tableData.search.locationId = this.locationsList[0].id;
  }
  getOfferPrice(items){
  for(let item of items){
    let today =new Date().toISOString();
    if(item.startTime < today && item.endTime > today){
      return item.offerPrice;
    }
  }
  }
  // For Page Index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }
  // To clear search fields
  clearSearch(value) {
    return this.productService.clearSearchFields(this.tableData, value);
  }
  listProduct(): void {
    const drawerRefCreate = this.drawerService.create<AddLocationProductComponentComponent, string>({
      //nzTitle : 'Create New Product',
      nzContent: AddLocationProductComponentComponent,
      nzWidth: '986px',
      nzMaskClosable: false,
      nzKeyboard: false,
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    drawerRefCreate.afterClose.subscribe(res => {
      this.refresh();
    });
  }
  editAvailability(
    row,
    merchantProductAssignLocationModal: TemplateRef<{}>
  ) {
    this.selectedProduct = row;
     this.commentForm.patchValue(row);
    this.productModal = this.modal.create({
      nzContent: merchantProductAssignLocationModal,
      nzClosable: false,
      nzMaskClosable: false,
      nzOkText: 'Yes',
      nzOnOk: () => this.updateAssignLocation(row),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Update Assign Location API
  updateAssignLocation(data) {
    const args = {
      merchantId: this.merchantId,
      productId: data.productId,
      locationId: this.tableData.search.locationId,
      isAvailable: this.commentForm.value.isAvailable,
      comments: this.commentForm.value.comments,
    }
    this.productService.editMerchantProductLocation(data.id, args).subscribe(
      (res) => {
        this.refresh();
        this.notification.success(Messages.updated, '', {
          nzKey: 'key'
        });
      },
      (error) => {
      });
  }
  // Delete confirmation popup
  assignLocationDelete(item) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want remove ' + item.productName + ' from ' + item.locationName + ' ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteProductLocation(item),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Delete API
  deleteProductLocation(item) {
    this.productService.deleteMerchantProductLocation(item.id).subscribe((response: any) => {
      this.notification.success(response.message, '', {
        nzKey: 'key'
      });
      this.refresh();
    }, err => {

    });
  }
  getMerchantCurrency(code) {
    return this.commonService.getMerchantCurrency(code);
  }

  // Create User drawer
  getOffersList(selectedRow): void {
    let data = selectedRow;
    const drawerRefCreate = this.drawerService.create<ProductOffersComponent, { selectedRow: string }, string>({
      nzContent: ProductOffersComponent,
      nzTitle: 'Offers',
      nzWidth: '900px',
      nzClosable: true,
      nzContentParams: {
        selectedRow: data
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    // For drawer close after save and to load the page
    drawerRefCreate.afterClose.subscribe(res => {
      if (res && typeof res !== null) {
        this.refresh();
      }
    });
  }
  getActiveOffersCount(data){
   if(data.length>0){
   return  data.filter(x=>x.status ===1).length
  }
  }
}